import Vue from 'vue'

const MODULE = {

  state: {
    activeChallenges: [],
    activeChallengesByOrg: [],
    archivedChallenges: [],
    archivedChallengesByOrg: [],
    currentlyViewedChallenge: {}
  },

  mutations: {
    setActiveChallenges (state, challenges) {
      Vue.set(state, 'activeChallenges', challenges)
    },

    setActiveChallengesByOrg (state, challenges) {
      Vue.set(state, 'activeChallengesByOrg', challenges)
    },

    updateActiveChallengesForOrg (state, challenges) {
      const org = state.activeChallengesByOrg.find(o => o.organization.uuid === challenges.organization.uuid)
      if (org) {
        org.challenges = challenges.challenges
      }
    },

    setArchivedChallenges (state, challenges) {
      Vue.set(state, 'archivedChallenges', challenges)
    },

    updateArchivedChallengesForOrg (state, challenges) {
      const org = state.archivedChallengesByOrg.find(o => o.organization.uuid === challenges.organization.uuid)
      if (org) {
        org.challenges = challenges.challenges
      }
    },

    setArchivedChallengesByOrg (state, challenges) {
      Vue.set(state, 'archivedChallengesByOrg', challenges)
    },

    setCurrentlyViewedChallenge (state, currentlyViewedChallenge) {
      state.currentlyViewedChallenge = currentlyViewedChallenge
    },

    updateActiveChallenge (state, challenge) {
      const index = state.activeChallenges.findIndex(c => c.uuid === challenge.uuid)
      if (index !== -1) {
        Vue.set(state.activeChallenges, index, challenge)
      }
    },

    updateArchivedChallenge (state, challenge) {
      const index = state.archivedChallenges.findIndex(c => c.uuid === challenge.uuid)
      if (index !== -1) {
        Vue.set(state.archivedChallenges, index, challenge)
      }
    },

    addActiveChallenge (state, challenge) {
      state.activeChallenges.push(challenge)
    },

    removeActiveChallenge (state, challengeUUID) {
      const index = state.activeChallenges.findIndex(challenge => challenge.uuid === challengeUUID)
      if (index !== -1) {
        state.challenges.splice(index, 1)
      }
    },

    removeArchivedChallenge (state, challengeUUID) {
      const index = state.archivedChallenges.findIndex(challenge => challenge.uuid === challengeUUID)
      if (index !== -1) {
        state.challenges.splice(index, 1)
      }
    }
  },

  actions: {
    requestActiveChallenges: async (context, params) => {
      const endpoint = '/api/v1/challenge'
      const allChallengesByOrg = []
      const pageInfos = {}

      if (params.fetchGlobal.length === 0) {
        for (const orgObj of context.rootState.auth.userInfo.organizations) {
          const queryParams = {
            org: orgObj.organization,
            size: params.pageSize,
            page: params.pageNum
          }

          const challengeResponse = await context.dispatch('authorizedFetch', {
            method: 'get',
            endpoint: endpoint,
            queryParams: queryParams
          })

          allChallengesByOrg.push({ organization: challengeResponse.organization, challenges: challengeResponse.challenges })

          pageInfos[orgObj.organization] = {
            numPages: Math.ceil(challengeResponse.matches / params.pageSize),
            pageSize: params.pageSize,
            pageNum: params.pageNum
          }
        }
      } else {
        for (const org of params.fetchGlobal) {
          const globalChallengeResponse = await context.dispatch('authorizedFetch', {
            method: 'get',
            endpoint: '/api/v1/challenge/global',
            queryParams: {
              org: org.uuid,
              size: params.pageSize,
              page: params.pageNum
            }
          })

          allChallengesByOrg.push({
            organization: globalChallengeResponse.organization,
            challenges: globalChallengeResponse.challenges
          })

          pageInfos[globalChallengeResponse.organization.uuid] = {
            numPages: Math.ceil(globalChallengeResponse.matches / params.pageSize),
            pageSize: params.pageSize,
            pageNum: params.pageNum
          }
        }
      }

      context.commit('setActiveChallengesByOrg', allChallengesByOrg)

      return pageInfos
    },

    requestActiveChallengesByOrg: async (context, params) => {
      let endpoint = ''

      if (params.global) {
        endpoint = '/api/v1/challenge/global'
      } else {
        endpoint = '/api/v1/challenge'
      }

      const queryParams = {
        org: params.orgId,
        size: params.pageSize,
        page: params.pageNum
      }

      const challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: endpoint,
        queryParams: queryParams
      })

      context.commit('updateActiveChallengesForOrg', {
        organization: challengeResponse.organization,
        challenges: challengeResponse.challenges
      })

      console.error(challengeResponse)

      return {
        numPages: Math.ceil(challengeResponse.matches / params.pageSize),
        pageSize: params.pageSize,
        pageNum: params.pageNum
      }
    },

    requestArchivedChallenges: async (context, params) => {
      const endpoint = '/api/v1/challenge'
      const pageInfos = {}
      const allChallengesByOrg = []
      if (params.fetchGlobal.length === 0) {
        for (const orgObj of context.rootState.auth.userInfo.organizations) {
          const queryParams = {
            org: orgObj.organization,
            archived: true,
            size: params.pageSize,
            page: params.pageNum
          }

          const challengeResponse = await context.dispatch('authorizedFetch', {
            method: 'get',
            endpoint: endpoint,
            queryParams: queryParams
          })

          allChallengesByOrg.push({
            organization: challengeResponse.organization,
            challenges: challengeResponse.challenges
          })

          pageInfos[orgObj.organization] = {
            numPages: Math.ceil(challengeResponse.matches / params.pageSize),
            pageSize: params.pageSize,
            pageNum: params.pageNum
          }
        }
      } else {
        for (const org of params.fetchGlobal) {
          const globalChallengeResponse = await context.dispatch('authorizedFetch', {
            method: 'get',
            endpoint: '/api/v1/challenge/global',
            queryParams: {
              org: org.uuid,
              size: params.pageSize,
              page: params.pageNum,
              archived: true
            }
          })

          allChallengesByOrg.push({
            organization: globalChallengeResponse.organization,
            challenges: globalChallengeResponse.challenges
          })
          pageInfos[globalChallengeResponse.organization.uuid] = {
            numPages: Math.ceil(globalChallengeResponse.matches / params.pageSize),
            pageSize: params.pageSize,
            pageNum: params.pageNum
          }
        }
      }

      context.commit('setArchivedChallengesByOrg', allChallengesByOrg)
      console.log(context.state.archivedChallengesByOrg)

      return pageInfos
    },

    requestArchivedChallengesByOrg: async (context, params) => {
      let endpoint = ''

      if (params.global) {
        endpoint = '/api/v1/challenge/global'
      } else {
        endpoint = '/api/v1/challenge'
      }

      const queryParams = {
        org: params.orgId,
        size: params.pageSize,
        page: params.pageNum,
        archived: true
      }

      const challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: endpoint,
        queryParams: queryParams
      })

      context.commit('updateArchivedChallengesForOrg', {
        organization: challengeResponse.organization,
        challenges: challengeResponse.challenges
      })

      return {
        numPages: Math.ceil(challengeResponse.matches / params.pageSize),
        pageSize: params.pageSize,
        pageNum: params.pageNum
      }
    },

    requestCurrentlyViewedChallenge: async (context, uuid) => {
      const challengeEndpoint = `/api/v1/challenge/${uuid}`

      var challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: challengeEndpoint
      })

      const participantEndpoint = `/api/v1/challenge/${uuid}/participants`

      var participantsResponse = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: participantEndpoint,
        queryParams: {
          challengeUUID: uuid
        }
      })

      console.log(participantsResponse)

      let participants = []
      let facilitators = []
      if (participantsResponse.success !== false) {
        participants = participantsResponse.participants.filter(p => p.scope === 'challenge_participant')
        participants = participants.map(p => p.uuid)
        facilitators = participantsResponse.participants.filter(p => {
          return (p.scope === 'challenge_facilitator') || (p.scope === 'challenge_cofacilitator')
        })
        facilitators = facilitators.map(f => f.uuid)
      }

      if (challengeResponse.success !== false && participantsResponse.success !== false) {
        challengeResponse.challenge = {
          ...challengeResponse.challenge,
          schedule: challengeResponse.schedule,
          participants: participants,
          facilitators: facilitators
        }
        console.log(challengeResponse)
        context.commit('setCurrentlyViewedChallenge', challengeResponse.challenge)
      }

      return challengeResponse
    },

    requestCreateChallenge: async (context, createChallengeParams) => {
      const createChallengeEndpoint = '/api/v1/challenge'

      const newChallengeResponse = await context.dispatch('authorizedFetch', {
        method: 'POST',
        endpoint: createChallengeEndpoint,
        body: {
          organization: createChallengeParams.organization,
          name: createChallengeParams.name,
          phrase: createChallengeParams.phrase,
          schedule: createChallengeParams.schedule
        }
      })

      if (newChallengeResponse.success !== false) {
        context.commit('addActiveChallenge', newChallengeResponse.challenge)

        const addParticipantsEndpoint = `/api/v1/challenge/${newChallengeResponse.challenge.uuid}/participants`
        await context.dispatch('authorizedFetch', {
          method: 'PUT',
          endpoint: addParticipantsEndpoint,
          body: {
            facilitators: createChallengeParams.facilitators,
            participants: createChallengeParams.participants
          }
        })
      }

      return newChallengeResponse
    },

    requestUpdateChallenge: async (context, updateChallengeParams) => {
      const endpoint = `/api/v1/challenge/${updateChallengeParams.uuid}`

      const challengeParamsWithoutParticipants = JSON.parse(JSON.stringify(updateChallengeParams))
      delete challengeParamsWithoutParticipants.participants
      delete challengeParamsWithoutParticipants.facilitators

      const updateChallengeResponse = await context.dispatch('authorizedFetch', {
        method: 'PUT',
        endpoint: endpoint,
        body: challengeParamsWithoutParticipants
      })

      if (updateChallengeResponse.success !== false) {
        const endpoint = `/api/v1/challenge/${updateChallengeParams.uuid}/participants`

        const updateChallengeParcicipantsResponse = await context.dispatch('authorizedFetch', {
          method: 'PUT',
          endpoint: endpoint,
          body: {
            facilitators: updateChallengeParams.facilitators,
            participants: updateChallengeParams.participants
          }
        })

        updateChallengeResponse.challenge = {
          ...updateChallengeResponse.challenge,
          schedule: updateChallengeResponse.schedule,
          facilitators: updateChallengeParcicipantsResponse.facilitators,
          participants: updateChallengeParcicipantsResponse.participants
        }
        if (updateChallengeResponse.challenge.archived) {
          context.commit('updateArchivedChallenge', updateChallengeResponse.challenge)
        } else {
          context.commit('updateActiveChallenge', updateChallengeResponse.challenge)
        }
      }

      return updateChallengeResponse
    },

    requestArchiveChallenge: async (context, challenge) => {
      const endpoint = `/api/v1/challenge/${challenge.uuid}/toggle`

      var challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'put',
        endpoint: endpoint
      })

      return challengeResponse.success
    },

    requestRestoreChallenge: async (context, challenge) => {
      const endpoint = `/api/v1/challenge/${challenge.uuid}/toggle`

      var challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'put',
        endpoint: endpoint
      })

      return challengeResponse.success
    },

    requestDeleteArchivedChallenge: async (context, challenge) => {
      const endpoint = `/api/v1/challenge/${challenge.uuid}`

      const challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'DELETE',
        endpoint: endpoint
      })

      context.commit('removeArchivedChallenge', challenge.uuid)

      return challengeResponse.success
    },

    requestDeleteChallenge: async (context, challenge) => {
      const endpoint = `/api/v1/challenge/${challenge.uuid}`

      const challengeResponse = await context.dispatch('authorizedFetch', {
        method: 'DELETE',
        endpoint: endpoint
      })

      context.commit('removeActiveChallenge', challenge.uuid)

      return challengeResponse.success
    },

    requestSearchUserByUUID: async (context, uuid) => {
      const endpoint = `/api/v1/user/${uuid}`

      const results = await context.dispatch('authorizedFetch', {
        method: 'GET',
        endpoint: endpoint
      })

      results.user.avatar = await context.dispatch('getAvatarFromUserName', results.user.name)

      return results.user
    },

    requestSearchUserByNameOrEmail: async (context, { query, organizationUUID, type }) => {
      let endpoint = ''
      if (type === 'participants') {
        endpoint = '/api/v1/user/participant'
      } else if (type === 'facilitators') {
        endpoint = '/api/v1/user/facilitator'
      }

      const queryParams = {
        org: organizationUUID,
        search: query
      }

      const results = await context.dispatch('authorizedFetch', {
        method: 'GET',
        endpoint: endpoint,
        queryParams: queryParams
      })

      for (const user of results.users) {
        user.avatar = await context.dispatch('getAvatarFromUserName', user.name)
      }

      return results
    }
  }
}

export default MODULE
